import { assert, BadRequestError } from '@fragment/error-utils';
import type { SafeString } from '@fragment/types/strings';
import { SafeStringSchema } from '@fragment/types/strings';

import { base64Decode, base64Encode } from '../encode';

type DecodedLedgerId = {
  ledgerId: SafeString;
};
export const encodeLedgerId = (ledger: { id: string }) =>
  base64Encode(`le:${ledger.id}`);

export const isEncodedId = (maybeEncoded: string) =>
  base64Decode(maybeEncoded).split(':')[0] === 'le';

export const decodeLedgerId = (encoded: string): DecodedLedgerId => {
  const decoded = base64Decode(encoded);

  const bits = decoded.split(':');
  assert(bits[0] === 'le', BadRequestError, {
    message: `Provided with an invalid Ledger ID: ${encoded}`,
  });

  return {
    ledgerId: SafeStringSchema.parse(bits[1]),
  };
};
